import { useContext } from 'react';
import WindowEventContext from '../context/window-event-context';
export default function useOnChange(itemId, setter, options) {
    if (options === void 0) { options = {}; }
    var _a = useContext(WindowEventContext), _onFieldUpdate = _a._onFieldUpdate, logger = _a.logger;
    var _b = options.extractor, extractor = _b === void 0 ? function (evt) { return evt.target.value; } : _b, commitOnOnChange = options.commitOnOnChange;
    var onChange = function (evt) {
        var val = extractor(evt);
        setter(val);
        if (commitOnOnChange) {
            logger.log("updating " + itemId + " from useOnChange with", { val: val });
            _onFieldUpdate(itemId, val);
        }
    };
    return {
        onChange: onChange,
    };
}
//# sourceMappingURL=useOnChange.js.map